export const GLOBAL_PANO_DIV_ID = 'pano';
export const NOT_TILTED_ICON_RESIZE_FACTOR = 1.2;
